<template>
  <f7-page>
    <f7-navbar  >
      <f7-nav-title class="text-madai">Wishlist</f7-nav-title>
    </f7-navbar>
    <!-- <div class="d-block text-center m-t-20">
      <img src="//madai.mx/img/wishlist.png" alt="" width="150">
    </div> -->
    <f7-list class="m-t-10 m-b-0" v-if="storage.wishlist.length">
      <f7-list-item
        v-for="(itm) in storage.wishlist"
        :key="itm.img"
        :link="itm.ida_articles ? `/argolla/${itm.ida_articles}/`
          : itm.idp_articles ? `/promesa/${itm.idp_articles}/`
          : itm.idac_articles ? `/compromiso/${itm.idac_articles}/`
          : itm.idc_articles ? `/churumbela/${itm.idc_articles}/`
          : itm.ida_zirconia ? `/zirconia/${itm.ida_zirconia}/`
          : itm.idar_articles ? `/aretes/${itm.idar_articles}/`
          : itm.iddj_articles ? `/dijes/${itm.iddj_articles}/`
          : itm.idpul_articles ? `/pulso/${itm.idpul_articles}/`
          : itm.idcj_articles ? `/conjuntos/${itm.idcj_articles}/`
          : `/cadenas/${itm.id_chain}/`"
      >
        <list-argolla v-if="itm.ida_articles" :itm="itm"></list-argolla>
        <list-cadena v-if="itm.id_chain" :itm="itm"></list-cadena>
        <list-churumbela v-if="itm.idc_articles" :itm="itm"></list-churumbela>
        <list-compromiso v-if="itm.idac_articles" :itm="itm"></list-compromiso>
        <list-promesa v-if="itm.idp_articles" :itm="itm"></list-promesa>
        <list-zirconia v-if="itm.ida_zirconia" :itm="itm"></list-zirconia>
        <list-aretes v-if="itm.idar_articles" :itm="itm"></list-aretes>
        <list-dije v-if="itm.iddj_articles" :itm="itm"></list-dije>
        <list-pulso v-if="itm.idpul_articles" :itm="itm"></list-pulso>
        <list-conjunto v-if="itm.idcj_articles" :itm="itm"></list-conjunto>
      </f7-list-item>
    </f7-list>
    <div class="m-t-0 text-center" v-else>
      <!-- <img class="wd-100" src="assets/img/empty-wishlist.svg" alt="" height="240"> -->
      <img src="assets/img/otros/wishlist_vacio.jpg" alt="" width="80%">
      <f7-block class="m-t-0 m-b-15">
        <div class="alert alert-secondary bold fs-16">Aún no has agregado nada a tu wishlist.</div>
        <img class="m-t-50" src="assets/img/otros/logo_bg.jpg" alt="" width="40%">
      </f7-block>
    </div>
    <f7-block class="wd-100 m-t-0" style="position: absolute; bottom: 0px;">
      <div class="bold text-center fs-12">
        2019 Madai. Todos los derechos reservados.
      </div>
    </f7-block>
  </f7-page>
</template>

<script>
import listArgolla from '@/components/list-argolla.vue'
import listCadena from '@/components/list-cadena.vue'
import listChurumbela from '@/components/list-churumbela.vue'
import listCompromiso from '@/components/list-compromiso.vue'
import listPromesa from '@/components/list-promesa.vue'
import listZirconia from '@/components/list-zirconia.vue'
import listAretes from '@/components/list-aretes.vue'
import listDije from '@/components/list-dije.vue'
import listPulso from '@/components/list-pulso.vue'
import listConjunto from '@/components/list-conjunto.vue'

export default {
  components: {
    listArgolla,
    listCadena,
    listChurumbela,
    listCompromiso,
    listPromesa,
    listZirconia,
    listAretes,
    listDije,
    listPulso,
    listConjunto
  }
}
</script>
